import React, { useState } from "react";
import { ProjectListItem } from "../types";
import ReactJson from "react-json-view";
import { Button, Collapse, Pre } from "@blueprintjs/core";
import "./ActionUpdates.scss";

type Props = {
    messages: Array<ProjectListItem>;
};

export default function ActionUpdates({ messages }: Props) {
    const [isOpen, setIsOpen] = useState<boolean>(true);
    return (
        <>
            <Button
                className="actions-button"
                text="Actions"
                intent="primary"
                icon={isOpen ? "chevron-down" : "chevron-right"}
                onClick={() => setIsOpen(!isOpen)}
            />
            <Collapse isOpen={isOpen}>
                <Pre>
                    {messages.map((m, idx) => (
                        <div className="action-list" key={idx}>
                            <div
                                // todo: move this style to css
                                style={{
                                    textAlign: "left",
                                    fontWeight: "lighter",
                                    fontSize: "17px",
                                    padding: "1rem 0 0 1rem",
                                    color: m.status === "Skipped" || m.status === "Canceled" ? "orange" : "white"
                                }}
                            >
                                {m.actionId} - {m.status}
                            </div>
                            <ReactJson
                                name="results"
                                collapsed={false}
                                src={m.results || {}}
                                style={{ textAlign: "left", fontSize: "15px", wordBreak: "break-all" }}
                                displayDataTypes={false}
                                displayObjectSize={false}
                                enableClipboard={false}
                                theme="ocean"
                            />
                        </div>
                    ))}
                </Pre>
            </Collapse>
        </>
    );
}
